// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"GallerySlider_sliderWrapper__+lYmi","imageContainer":"GallerySlider_imageContainer__yHAvs","image":"GallerySlider_image__FVBSV"};